import {
  FilterType,
  buildMaterializedProcessesDataTableFilter,
  useMaterializedProcessesDataTable,
} from 'generated/resources/datatable.graphql'
import {
  ProcessesMaterializedProcessStatusEnum,
  ProcessesMaterializedProcessStatusEnumValues,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

const label = (status: ProcessesMaterializedProcessStatusEnum) => {
  switch (status) {
    case 'running':
      return i18n.t('processes.materialize_process.statuses.running')
    case 'finalized':
      return i18n.t('processes.materialize_process.statuses.finalized')
    default:
      return ''
  }
}

const options = () =>
  ProcessesMaterializedProcessStatusEnumValues.map((status) => ({
    label: label(status),
    value: status,
  })).filter((option) => option.label)

const statusFilter = (source: ReturnType<typeof useMaterializedProcessesDataTable>) =>
  buildMaterializedProcessesDataTableFilter(source, {
    default: true,
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options: options(),
        value: 'running',
      },
    ],
    identifier: 'materializedProcesss.statusFilter',
    path: 'status',
    title: i18n.t('processes.process.employee.table.filters.status'),
  })

export default statusFilter
